import { render, staticRenderFns } from "./threadList.vue?vue&type=template&id=e044376c&"
import script from "./threadList.vue?vue&type=script&lang=js&"
export * from "./threadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports